import { fetcher } from "utils";

import { IJSendSuccessResponse, MemberSerialized, Provider } from "typings";

export function delete__members__social_accounts(
  provider: Provider
): Promise<IJSendSuccessResponse<{ member: MemberSerialized }>> {
  return fetcher.delete("/members/social_accounts", { provider });
}
